
import React from 'react';
import { HeaderLeft } from '../TopNavigation/HeaderLeft';
import { ParagraphLRegular } from '../../config/designSystem/typography';
import { StyleSheet, View } from 'react-native';
import { concatPath } from '../../utils/links/concatPath';
import { dashboardStackKey } from '../../constants/routeKeys';
import { router } from 'expo-router';

interface ErrorProps {
    network?: boolean;
    labels: {
        GENERIC?: string;
        NETWORK?: string;
    };
}

const Error = ({ network, labels }: ErrorProps) => {

  const goToHome = () => {

    router.navigate(concatPath([dashboardStackKey ], 2) as string);
  };


  return (
    <View>
      <HeaderLeft topPosition={30} leftPosition={30} onPress={() => {
        if(router.canGoBack()){
          router.back();
        } else {
          goToHome();
        }}}/>
      <View style={styles.error}>
        <ParagraphLRegular>
          {network ? labels?.NETWORK : labels?.GENERIC}
        </ParagraphLRegular>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  error: {
    alignItems: 'center',
    justifyContent: 'center',
    margin: 40,
    marginTop: 200
  }
});

export default Error;
